// extracted by mini-css-extract-plugin
export default {"title":"styles_title__sWR63","flex":"styles_flex__rrsLp","block":"styles_block__KbmKk","icon":"styles_icon__GtOz4"};